export default "__VITE_ASSET__DIrx93s7__"